import { ActionTypes } from '../constants/index';

export const fetchMasterReason = (payload: any) => ({
  type: ActionTypes.MASTER_REASON_MGMT_REQUEST,
  payload,
});
